import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

export const ACTION_PREFIX = "[Data Protection]";

export const DATA_PROTECTION_ACTION_TYPE = {
	getGdprEnabledCountries: `${ACTION_PREFIX} Get GDPR Enabled Countries`,
	getGdprEnabledCountriesSuccess: `${ACTION_PREFIX} Get GDPR Enabled Countries Success`,
	getGdprEnabledCountriesFail: `${ACTION_PREFIX} Get GDPR Enabled Countries Fail`,
};

@Injectable({
	providedIn: "root",
})
export class DataProtectionAction {
	getGdprEnabledCountries(): Action {
		return {
			type: DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountries,
		};
	}

	getGdprEnabledCountriesSuccess(payload: string[]): ActionWithPayload {
		return {
			type: DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountriesSuccess,
			payload,
		};
	}

	getGdprEnabledCountriesFail(error: AppError): ActionWithPayload {
		return {
			type: DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountriesFail,
			payload: error,
		};
	}
}
